export default __webpack_public_path__ + "static/media/pricing1.fff65ebe.gif";